const validate = (inputs) => {
    //Email errors
    const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
    let errors = {
        valid: true,
    };

    if (!validEmailRegex.test(inputs.email)) {
        errors.emailError = 'Enter a valid email ID';
        errors.valid = false;
    } else if (!inputs.email) {
        errors.emailError = 'Enter Email';
        errors.valid = false;
    }

    return errors;
}
export default validate;